/* GENERATED FILE */
import React, { useContext, useMemo } from 'react';
import { IconProps, IconContext } from '../lib';

import bold from '../bold/EnvelopeSimpleOpen';
import duotone from '../duotone/EnvelopeSimpleOpen';
import fill from '../fill/EnvelopeSimpleOpen';
import light from '../light/EnvelopeSimpleOpen';
import regular from '../regular/EnvelopeSimpleOpen';
import thin from '../thin/EnvelopeSimpleOpen';

function EnvelopeSimpleOpen({ weight, color, size, style }: IconProps) {
  const {
    color: contextColor = '#000',
    size: contextSize = 24,
    weight: contextWeight = 'regular',
    style: contextStyle,
  } = useContext(IconContext);

  const IconComponent = useMemo(() => {
    const iconWeight = weight ?? contextWeight;

    const weightMap = {
      bold,
      duotone,
      fill,
      light,
      regular,
      thin,
    };

    return weightMap[iconWeight];
  }, [weight, contextWeight]);

  return (
    <IconComponent
      color={color ?? contextColor}
      size={size ?? contextSize}
      style={{
        ...contextStyle,
        ...style,
      }}
    />
  );
}

export default EnvelopeSimpleOpen;
